import { css } from '@emotion/react';

/**
 * Braze 의 InAppMessage 의 zIndex 를 Customize 처리함
 * (상품상세 페이지에서의 메뉴탭의 z-index 는 19000 (fixedBar)
 * */
const brazeInAppCustom = css`
  body .ab-iam-root {
    z-index: 19000 !important;
  }
`;

export default brazeInAppCustom;
